import React from "react";
import "./style.css";

const Details = ({ data }) => {
  return (
    <div class="chmp-detail container-fluid box-outer-sec mt-4">
      {data?.activityDetails?.description?.details?.length > 0 &&
        <>
          <div class="detail-heading sec-heading">
            <h5>Details</h5>
          </div>
          <div class="details-list-sec py-4">
            {data?.activityDetails?.description?.details?.map(item => <li className="nav-item">{item}</li>)}
          </div>
        </>
      }
    </div>
  );
};

export default Details;
